import React from 'react';
import { Dialog } from '@material-ui/core';

import { ReactComponent as IconClose } from '../../assets/svgs/icon-close.svg';

interface Props {
  isOpen: boolean;
  closeDialog: () => void;
}

export enum BulkMessageSuccessModalTestID {
  BulkMessageSuccessModalCloseButton = 'BulkMessageSuccessModalCloseButton',
  BulkMessageSuccessModalBackButton = 'BulkMessageSuccessModalBackButton',
}

export const BulkMessageSuccessModal: React.FC<Props> = ({ closeDialog, isOpen }) => {
  return (
    <Dialog open={isOpen} onClose={closeDialog} aria-labelledby="form-dialog-title" fullWidth>
      <div className="p-4 h-full relative">
        <div
          data-testid={BulkMessageSuccessModalTestID.BulkMessageSuccessModalCloseButton}
          onClick={closeDialog}
          className="bg-gray-300 hover:bg-gray-200 cursor-pointer rounded-full h-10 w-10 absolute top-4 right-4 flex justify-center items-center"
        >
          <IconClose className="w-3 h-3 text-gray-1000 fill-current stroke-current" />
        </div>

        <div className="flex flex-col justify-center px-24 items-center mt-4">
          <p className="font-bold text-black text-2xl mb-4">
            Bulk Messages Sent!{' '}
            <span role="img" aria-label="party-popper">
              🎉
            </span>
          </p>
          <p className="text-gray-700 text-sm mb-4 text-center">
            You’re all set! It’s time to kick your feet back and relax while we take care of the
            heavy lifting.{' '}
          </p>
          <button
            data-testid={BulkMessageSuccessModalTestID.BulkMessageSuccessModalBackButton}
            onClick={closeDialog}
            className="px-12 outline-none h-10 flex font-extrabold justify-center items-center text-white p-2 rounded hover:shadow-md bg-blue-200"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </Dialog>
  );
};
